import * as crypto from 'crypto-js';
import { formatDate } from "@angular/common";
import { Component, OnInit } from '@angular/core';


@Component({
	selector: 'app-proceedings',
	templateUrl: './proceedings.component.html',
	styleUrls: ['./proceedings.component.css']
})
export class ProceedingsComponent implements OnInit {
	
	constructor() {}

	ngOnInit(): void {}
	
}